import { useEffect } from "react";
import { SITE, STORE } from "@/config/sections";

// Tells Google who runs the shop (name, logo, socials, contact) and enables the sitelinks search box.
export const SiteJsonLd = () => {
  useEffect(() => {
    const url = "https://pettokshop.net";
    const data = [
      {
        "@context": "https://schema.org",
        "@type": "OnlineStore",
        name: SITE.name,
        url,
        logo: `${url}/icons/icon-512.png`,
        image: `${url}${SITE.heroImage}`,
        description: SITE.tagline,
        email: STORE.email,
        sameAs: SITE.socials.map((s) => s.url),
        hasMerchantReturnPolicy: {
          "@type": "MerchantReturnPolicy",
          applicableCountry: "US",
          returnPolicyCategory: "https://schema.org/MerchantReturnFiniteReturnWindow",
          merchantReturnDays: 30,
          returnMethod: "https://schema.org/ReturnByMail",
          returnFees: "https://schema.org/FreeReturn",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: SITE.name,
        url,
        potentialAction: { "@type": "SearchAction", target: `${url}/shop?q={search_term_string}`, "query-input": "required name=search_term_string" },
      },
    ];
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.text = JSON.stringify(data);
    document.head.appendChild(el);
    return () => el.remove();
  }, []);
  return null;
};
